{
  "_provenance": {
    "ns": "help",
    "source": "pages/HelpPage.tsx and pages/help-copy-parent.ts values (R3-B25) (#2109 R3 lane L6)"
  },
  "page": {
    "ask": "Ask {{companion}} about this →",
    "askPrompt": "Tell me about the {{section}} section and how I can use it",
    "clearSearch": "Clear search",
    "documentTitle": "How can we help?",
    "noResults": "No help topics match “<query>{{query}}</query>”.",
    "parentSubtitle": "Learn about every section of your dashboard and how {{companion}} can help you navigate it.",
    "searchLabel": "Search help topics",
    "searchPlaceholder": "Search help topics…",
    "sectionLabel": "Section",
    "title": "How can we <em>help</em>?"
  },
  "parent": {
    "bills": {
      "description": "Your grants: what TRF approved, what is left on each, and your Signature Grant renewal when it opens. Your receipts: drop a photo and we read the merchant, date, amount and category for you, or add an expense by hand and attach its receipt later. Each expense says where it stands in plain words, month by month, and anything that still needs you sits at the top."
    },
    "calendar": {
      "description": "All your medical appointments, medication times, and task dates in one view. Filter by category to focus on what you need right now.",
      "memorial": "Your task dates and everything else you are keeping track of, in one view."
    },
    "circle": {
      "description": "Your TRF contact — who to write to, and when to expect a reply — and the resources TRF has gathered for your family."
    },
    "community": {
      "description": "A private space for families supported by TRF to share experiences, ask questions, and find support. Posts are moderated to keep the space safe and supportive."
    },
    "dashboard": {
      "description": "Where you start: ask {{companion}} anything, typed or by voice, with a few ideas to begin from. Under that, one thing {{companion}} noticed that is waiting on you — an appointment coming up, an overdue to-do, a question from TRF.",
      "memorial": "Where you start: ask {{companion}} anything, typed or by voice. {{companion}} is there when you want her, and stays quiet when you don’t."
    },
    "medical": {
      "description": "Log symptoms over time, keep the medication list current, and store questions for the care team. Appointments live on the calendar. Private to your family’s account. TRF staff can see it so they can support you."
    },
    "settings": {
      "description": "Manage your notification preferences, voice persona, and account security, and set up two-factor authentication. Every conversation you have had with {{companion}} is here too, under Companion — newest first, so you can reopen one and pick up where you left off."
    },
    "tasks": {
      "description": "Keep the asks — rides, meals, errands — on one list your family can track. {{companion}} can suggest what to ask for based on your situation."
    }
  }
}
